// One-time TY 2025 UI policy; remove when opening TY 2026 filing.
const KEY = "ty2025FilingAvailability";
const EVENT = "ty2025-filing-availability";

export const getFilingClosure = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY));
    const email = localStorage.getItem("userEmail")?.toLowerCase();
    return email && saved?.email === email && typeof saved.closed === "boolean"
      ? saved.closed : null;
  } catch {
    return null;
  }
};

export const storeFilingAvailability = (data) => {
  if (typeof data?.ty2025_filing_closed !== "boolean" || !data?.email) return;
  const email = data.email.toLowerCase();
  if (email !== localStorage.getItem("userEmail")?.toLowerCase()) return;
  localStorage.setItem(KEY, JSON.stringify({ email, closed: data.ty2025_filing_closed }));
  window.dispatchEvent(new Event(EVENT));
};

export const clearFilingAvailability = () => {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(EVENT));
};

export const subscribeFilingAvailability = (listener) => {
  window.addEventListener(EVENT, listener);
  window.addEventListener("storage", listener);
  return () => {
    window.removeEventListener(EVENT, listener);
    window.removeEventListener("storage", listener);
  };
};
